import React, { useState, useEffect, useContext } from "react";
import UserDelagateProductReadOnlyRow from "./UserDelagateProductReadOnlyRow";
import UserDelegateProductTableRow from "./UserDelegateProductTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";


function UserDelegateProductTable({ key, setDelegateProduct, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isUserDelegateProductLoading, setIsUserDelegateProductLoading] = useState(false);
	const [userDelegateProducts, setUserDelegateProducts] = useState([]);
	const [isUserDelegateLoading, setIsUserDelegateLoading] = useState(false);
	const [userDelegates, setUserDelegates] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		delegateCompanyId: 0,
		companyProductKey: 0,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = userCtx.userCompanyId;
	useEffect(() => {
		fetchUserDelegates();
		fetchUserDelegateProducts();
	}, []);

	const handleClose = (event) => {
		setDelegateProduct(false);
	};


	function fetchUserDelegates() {
		if (companyId === 0 || !loginId) {
			return;
		}
		resetCounter();
		setIsUserDelegateLoading(false);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: true,
				companyId: companyId,
				loginId: loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("MGetUserDelegates", "/Service/UserService/GetUserDelegates", requestOptions, getUserDelegatesSuccess, getUserDelegatesFail);
		} catch (error) {
			setIsUserDelegateLoading(false);
			throw new Error(error.message);
		}
	}

	function getUserDelegatesFail(redirect) {
		setIsUserDelegateLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userDelegateNotRetrieved"));
	}

	function getUserDelegatesSuccess(responseData) {
		let userDelegatesResponse;
		setUserDelegates([]);
		if (responseData) {
			userDelegatesResponse = responseData.getUserDelegatesResponse;
			if (userDelegatesResponse && userDelegatesResponse.errorCode === "0") {
				setUserDelegates([...userDelegatesResponse.delegates]);
			} else if (userDelegatesResponse && userDelegatesResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (userDelegatesResponse) {
				setError(t("error.error") + " " + userDelegatesResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserDelegateLoading(false);
	}


	function fetchUserDelegateProducts() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsUserDelegateProductLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId, userCompanyId: userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserDelegateProduct", "/Service/UserService/GetUserDelegateProduct", requestOptions, retrieveDelegateProductSuccess, retrieveDelegateProductFail);
		} catch (error) {
			setIsUserDelegateProductLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveDelegateProductFail(redirect) {
		setIsUserDelegateProductLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.delegateGetProductFailed"));
	}

	function retrieveDelegateProductSuccess(responseData) {
		let fetchUserDelegateProductResponse;
		if (responseData) {
			fetchUserDelegateProductResponse = responseData.getUserDelegateProductsResponse;
			if (fetchUserDelegateProductResponse && fetchUserDelegateProductResponse.errorCode === "0") {
				setUserDelegateProducts(fetchUserDelegateProductResponse.products.slice())
			} else if (fetchUserDelegateProductResponse && fetchUserDelegateProductResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserDelegateProductResponse) {
				setError(t("error.error") + " " + fetchUserDelegateProductResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserDelegateProductLoading(false);
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};

	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleDeleteClick = (event, userDelegateItem, completeCallback) => {
		event.preventDefault();
		deleteUserDelegateProduct(userDelegateItem, completeCallback);
	};
	const deleteUserDelegateProduct = (userDelegateItem, completeCallback) => {
		let action = 3;
		if (userDelegateItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			userDelegateProductKey: userDelegateItem.userDelegateProductKey,
			loginId: initialValues.loginId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserDelegateProduct", "/Service/UserService/DeleteUserDelegateProduct", requestOptions, 
			deleteDelegateProductSuccess, deleteDelegateProductFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteDelegateProductFail(redirect, completeCallback) {
		setError(t("error.userProdEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteDelegateProductSuccess(responseData, completeCallback) {
		let deleteUserDelegateProductResponse;
		if (responseData) {
			deleteUserDelegateProductResponse = responseData.deleteUserDelegateProductResponse;
			if (deleteUserDelegateProductResponse) {
				if (deleteUserDelegateProductResponse.errorCode === "0") {
					resetRowTable();
					refreshUserDelegateProduct();
				} else {
					setError(t("error.error") + " " +
						deleteUserDelegateProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (userDelegateProducts.length > 0) {
				userDelegateProducts.map((delegateProductItem, index) => {
					if (delegateProductItem.companyProductKey === setValues.companyProductKey && 
						delegateProductItem.delegateCompanyId === setValues.delegateCompanyId && 
						delegateProductItem.userDelegateKey == setValues.userDelegateKey &&
						delegateProductItem.buyerKey == setValues.buyerKey &&
						delegateProductItem.indirectBuyerKey == companyId &&
						delegateProductItem.delegateProductKey == setValues.delegateProductKey){
						setError(t("error.prodDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveUserDelegateProduct(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (completeCallback) {
			completeCallback();
		}
	};
	const saveUserDelegateProduct = (action, setValues, completeCallback) => {
		let serverParams = {
			userDelegateProductKey: setValues.userDelegateProductKey,
			loginId: formValues.loginId,
			indirectBuyerKey: formValues.companyId,
			companyId: setValues.delegateCompanyId,
			buyerKey: setValues.buyerKey,
			userDelegateKey: setValues.userDelegateKey,
			level: setValues.level,
			companyProductKey: setValues.companyProductKey,
			delegateProductKey: setValues.delegateProductKey,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserDelegateProduct", "/Service/UserService/AddUpdateUserDelegateProduct", requestOptions, 
			saveDelegateProductSuccess, saveDelegateProductFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveDelegateProductFail(redirect, completeCallback) {
		setError(t("error.prodEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveDelegateProductSuccess(responseData, completeCallback) {
		let addUpdateUserDelegateProductResponse;
		if (responseData) {
			addUpdateUserDelegateProductResponse = responseData.addUpdateUserDelegateProductResponse;
			if (addUpdateUserDelegateProductResponse) {
				if (addUpdateUserDelegateProductResponse.errorCode === "0") {
					resetRowTable();
					refreshUserDelegateProduct();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserDelegateProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshUserDelegateProduct() {
		fetchUserDelegateProducts();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{( isUserDelegateProductLoading || isUserDelegateLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("header.admin.delegate")}</th>
										<th className="list-th">{t("page.product")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<UserDelegateProductTableRow
											index={count}
											userDelegates={userDelegates}
											companyId={companyId}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDelegateProducts.length % 2) > 0) ? true : false} />
									}
									{(userDelegateProducts.length > 0) ? (
										userDelegateProducts.map((delegateProductItem, index) => (
											<UserDelagateProductReadOnlyRow
												index={count}
												t={t}
												delegateProductItem={delegateProductItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												setError={setError}
												handleSubmit={handleSubmit}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<UserDelegateProductTableRow
											index={count}
											userDelegates={userDelegates}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDelegateProducts.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(userDelegateProducts.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("header.admin.delegate")}</th>
										<th className="list-th">{t("page.product")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-sub-appsurvey-close"
									id="edit-sub-appsurvey-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default UserDelegateProductTable;